import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {MawakibService} from "../../serverService/mawakibService/MawakibService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {RouteHelper} from "../../route/RouteHelper";
import {
    convertUniversalDateTimeToPersianDateTime, RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary, RaikoCreatorInfo,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn, RaikoSectionContainer, RaikoSimpleInputOutlined, RaikoToggleOutlined,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import {css} from "@emotion/css";

export default function MawakibLocationDetails() {

    const {id:mawkibLocationId=-1}=useParams()
    const {state}=useLocation()
    const [selectedValueTabMenu, setSelectedValueTabMenu] = useState(mawakibLocationTabType.BasicInformation.id);

    const service = new MawakibService();
    const loading = new LoadingHelper(useLoadingDispatcher());

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.MawakibRegistrationLocation.name);

    const [locationTitle, setLocationTitle] = useState("");
    const [groupLink, setGroupLink] = useState("")
    const [enabled, setEnabled] = useState(true)
    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");

    function handleChangeTabMenu(event, newValue) {
        setSelectedValueTabMenu(newValue)
    }

    useEffect(() => {
        if (typeof service !== 'undefined'){
            getMawkibLocationDetailsFromServer()
        }
    }, []);

    function getMawkibLocationDetailsFromServer() {
        loading.show()
        service.getMawkibLocationDetails(mawkibLocationId)
            .then(response=>{
                setLocationTitle(response.title)
                setGroupLink(response.groupLink)
                setEnabled(response.enabled)
                setCreatedBy(response.createdBy)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_=>{
            loading.hide()
        })

    }

    const navigate = useNavigate()


    return(
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MawakibManager.name,
                                RouteHelper.MawakibManager.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MawakibRegistrationLocation.name,
                                RouteHelper.MawakibRegistrationLocation.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            )
                        ]}
                    />
                    <RaikoButtonSecondary label={"بازگشت"} onClick={_ => {
                        navigate(-1)
                    }}/>
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={selectedValueTabMenu}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={mawakibLocationTabType.BasicInformation.title}
                                value={mawakibLocationTabType.BasicInformation.id}
                            />
                        </TabList>

                    </Box>
                    <TabPanel value={mawakibLocationTabType.BasicInformation.id}>
                        <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                            <RaikoBaseCardContainer>
                                <RaikoSectionContainer title={mawakibLocationTabType.BasicInformation.title}>
                                    <RaikoSimpleInputOutlined
                                        labelText={"عنوان"}
                                        value={locationTitle}
                                        setValue={setLocationTitle}
                                    />
                                    <RaikoSimpleInputOutlined
                                        labelText={"لینک گروه"}
                                        value={groupLink}
                                        setValue={setGroupLink}
                                    />
                                    <RaikoToggleOutlined
                                        checked={enabled}
                                        setChecked={setEnabled}
                                        labelText={"وضعیت"}
                                    />
                                </RaikoSectionContainer>
                            </RaikoBaseCardContainer>
                            <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>
                        </RaikoGridOneColumn>

                    </TabPanel>

                </TabContext>

            </RaikoGridOneColumn>

        </RaikoBaseContainer>
    )
}
const mawakibLocationTabType = {
    BasicInformation: {
        id: "basic-information",
        title: "اطلاعات پایه",
    },
}